import type { NoddiAsyncError } from 'noddi-types';
import { getFirstErrorCode } from 'noddi-util';
import type { NotificationGroupOverviewTranslations } from './notificationTranslations';

/**
 * The add-member endpoint answers in English, which a customer-app admin reads in a Norwegian UI.
 * The refusals an admin can act on are mapped to the wizard's own copy; anything else falls through
 * to the raw backend detail, which is still better than nothing for support.
 */
export const addMemberErrorMessage = (
  error: NoddiAsyncError | null,
  t: NotificationGroupOverviewTranslations
): string | undefined => {
  if (!error) {
    return undefined;
  }
  switch (getFirstErrorCode(error)) {
    case 'user_group_member_add_email_taken':
      return t.memberEmailTaken;
    case 'user_group_member_already_member':
      return t.memberAlreadyInGroup;
    case 'user_group_member_add_user_unavailable':
      return t.memberUnavailable;
    case 'user_group_member_add_requires_name':
      return t.memberNotFound;
    default:
      return undefined;
  }
};
